import { InsufficientAccess } from "./InsufficientAccess.component";

export default InsufficientAccess;
